import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

// Auth Components
import Login from './pages/auth/Login';
// import Register from './pages/auth/Register';

// User Components
import UserDashboard from './pages/user/Dashboard';
import UserProfile from './pages/user/Profile';

// Admin Components
import AdminDashboard from './pages/admin/Dashboard';
import UserManagement from './pages/admin/UserManagement';
import UserDetails from './pages/admin/UserDetails';
import Questions from './pages/admin/Questions';
import ImportData from './pages/admin/ImportData';
import AnswerQuestions from './pages/admin/AnswerQuestions';
import VoterDetails from './pages/admin/VoterDetails';
import AllTelecallers from './pages/admin/AllTelecallers';
import AllVoters from './pages/admin/AllVoters';


import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <div className="App">
        <Routes>
         
          <Route path="/login" element={<Login />} />
         

          
          <Route path="/user" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Navigate to="/user/dashboard" replace />} />
            <Route path="dashboard" element={<UserDashboard />} />
            <Route path="profile" element={<UserProfile />} />
          </Route>

          
          <Route path="/admin" element={
            <AdminRoute>
              <Layout />
            </AdminRoute>
          }>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="telecallers" element={<AllTelecallers />} />
            <Route path="voters" element={<AllVoters />} />
            <Route path="users/:id" element={<UserDetails />} />
            <Route path="questions" element={<Questions />} />
            <Route path="import-data" element={<ImportData />} />
            <Route path="answer-questions" element={<AnswerQuestions />} />
            <Route path="/admin/voter-details/:id" element={<VoterDetails />} />
          </Route>

          
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
